export const ADMIN_EMAIL = 'admin@acme.co.uk'

export const DOCUMENTS_ALLOWED_FILE_TYPES = '.docx,.jpg,.pdf,.png,.csv,.xls,.xlsx'

export const DOCUMENTS_STORAGE_CAPACITY = 2

export const DOCUMENTS_FILE_SPECIAL_CHARACTER_ALLOWED = /^[a-zA-Z0-9\s+\-=_()!@./]+$/

export const DOCUMENTS_COMMENT_SPECIAL_CHARACTER_ALLOWED = /^[a-zA-Z0-9\s+\-=_@./]+$/